import { Injectable, signal } from '@angular/core';
import { Assembly } from 'src/app/models/assembly.model';
import { AssembliesService } from '../api/assemblies.service';

@Injectable({
  providedIn: 'root'
})
export class AssemblyCacheService {
  assemblies = signal<Assembly[]>([]);
  currentFID = signal<number>(0);
  filteredAssemblies = signal<Assembly[]>([]);
  private fetchInProgress: { [key: number]: boolean } = {};

  categoryID:number = 0;
  types:string[] = [];
  sFID:number = 0;
  oFID:number = 0;

  selectedAssembly = signal<Assembly | null>(null);

  constructor(private assembliesService: AssembliesService) { }

//   fetchAssembliesByFid(fid: number): Assembly[] {
//     const assemblies = this.assemblies().filter(assembly => assembly.FID === fid);
//     if (assemblies.length === 0 && this.currentFID() !== fid) {
//         // Check if a fetch is already in progress for this FID
//         if (!this.fetchInProgress[fid]) {
//             this.fetchInProgress[fid] = true;
//             this.currentFID.set(fid);
//             this.assembliesService.getFullCatalog(fid).subscribe(assemblies => {
//                 this.assemblies.set([...this.assemblies(), ...assemblies]);
//                 this.fetchInProgress[fid] = false; // Reset the flag
//             }, error => {
//                 console.error('Error fetching assemblies: ', error);
//                 this.fetchInProgress[fid] = false; // Reset the flag
//             });
//         }
//         return [];
//     } else {
//         return assemblies;
//     }
// }

fetchAssembliesByFid(standardsFid: number, optionsFid: number): Assembly[] {
  console.log('fetching assemblies by FID:', standardsFid, optionsFid);
  const oFID = optionsFid;
  const sFID = standardsFid;
  console.log('fetching assemblies by FID:', sFID, oFID);
  const assemblies = this.assemblies().filter(assembly => (assembly.FID === oFID && assembly.Type === 'O') || (assembly.FID === sFID && assembly.Type !== 'O'));
  if (assemblies.length === 0 && this.currentFID() !== oFID) {
      // Check if a fetch is already in progress for this FID
      if (!this.fetchInProgress[oFID]) {
          this.fetchInProgress[oFID] = true;
          this.currentFID.set(oFID);
          this.assembliesService.getFullCatalog(oFID).subscribe(assemblies => {
              this.assemblies.set([...this.assemblies(), ...assemblies]);
              this.fetchInProgress[oFID] = false; // Reset the flag
          }, error => {
              console.error('Error fetching assemblies: ', error);
              this.fetchInProgress[oFID] = false; // Reset the flag
          });
      }
      return [];
  } else {
      return assemblies;
  }
}

  filterAssemblies(categoryId: number, standardsFid: number, optionsFid: number, types?: string[]) {
    this.categoryID = categoryId;
    this.sFID = standardsFid;
    this.oFID = optionsFid;
    this.types = types || [];
    console.log('filtering assemblies for FID:', standardsFid, optionsFid);
    let assemblies = this.fetchAssembliesByFid(standardsFid,optionsFid).filter(assembly => assembly.CategoryID === categoryId);
    if(types) {
      assemblies = assemblies.filter(assembly => types.includes(assembly.Type));
    }
    // console.log('filtered assemblies', assemblies);
    this.filteredAssemblies.set(assemblies);
  }

//   updateAssembly(request: Assembly) {
//     console.log('updating assembly', request);
//     const updatedAssemblies = this.assemblies().map(assembly => 
//         assembly.AID === request.AID ? request : assembly
//     );
//     this.assemblies.set(updatedAssemblies);
// }

  updateAssemblies(assembly: Assembly) {
    const assemblies = this.assemblies();
    if(assemblies.find(a => a.AID === assembly.AID)) {
      const index = assemblies.findIndex(a => a.AID === assembly.AID);
      assemblies[index] = assembly;
      this.assemblies.set(assemblies);
    } else {
      this.assemblies.set([...assemblies, assembly]);
    }
    console.log('updating assemblies for FID:', this.sFID, this.oFID);
    this.filterAssemblies(this.categoryID, this.sFID, this.oFID, this.types);
  }

  setSelectedAssembly(assembly: Assembly) {
    this.selectedAssembly.set(assembly);
  }
}
